/* it's FPV v1.0 Legal Guarantee.
 *
 * Opens the EU legal guarantee notice from the footer link in a native modal
 * <dialog>: showModal() makes the rest of the page inert (Tab stays inside,
 * nothing outside can take focus), Esc closes natively. We add: the close
 * button, a click on the backdrop closes, the page behind does not scroll
 * (Dawn's .overflow-hidden on <body>), focus returns to the link, and a tap on
 * the notice toggles a 2x zoom that keeps the tapped point under the finger.
 *
 * Without JS, or without <dialog> support, the link opens the SVG itself.
 * Delegated listeners only, nothing to clean up on section reloads.
 */
(() => {
  if (window.itsfpvLegalGuarantee) return;
  window.itsfpvLegalGuarantee = true;

  const DIALOG = 'dialog.legal-guarantee-modal';
  let opener = null;

  function open(link) {
    const id = link.getAttribute('aria-controls');
    const dialog = id && document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.parentElement !== document.body) {
      // Out of the black footer, onto the page's own colour scheme. A copy left
      // in <body> by an earlier render (Theme Editor reloads) goes first.
      document.querySelectorAll(`body > ${DIALOG}`).forEach((old) => old.remove());
      document.body.appendChild(dialog);
    }
    // Every opening starts with the whole notice in view.
    dialog.querySelectorAll('[data-legal-guarantee-zoom]').forEach((img) => img.removeAttribute('data-zoomed'));
    opener = link;
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function zoom(img, event) {
    const frame = img.closest('[data-legal-guarantee-frame]');
    if (!frame) return;
    const box = img.getBoundingClientRect();
    const view = frame.getBoundingClientRect();
    // Share of the notice under the pointer, and where the pointer sits in the frame.
    const fx = (event.clientX - box.left) / box.width;
    const fy = (event.clientY - box.top) / box.height;
    const px = event.clientX - view.left;
    const py = event.clientY - view.top;
    img.toggleAttribute('data-zoomed');
    frame.scrollLeft = img.offsetLeft + fx * img.offsetWidth - px;
    frame.scrollTop = img.offsetTop + fy * img.offsetHeight - py;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-legal-guarantee-open]');
    if (link) {
      // Modifier clicks keep the browser's own behaviour (the SVG in a new tab).
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (open(link)) event.preventDefault();
      return;
    }
    const close = event.target.closest('[data-legal-guarantee-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    // The dialog element is the dimmed overlay; its box sits inside it.
    if (event.target.matches && event.target.matches(DIALOG)) {
      event.target.close();
      return;
    }
    const img = event.target.closest('[data-legal-guarantee-zoom]');
    if (img) zoom(img, event);
  });

  // 'close' does not bubble: listen in the capture phase. Fires for Esc too.
  document.addEventListener(
    'close',
    (event) => {
      if (!event.target.matches || !event.target.matches(DIALOG)) return;
      document.body.classList.remove('overflow-hidden');
      if (opener && opener.isConnected) opener.focus();
      opener = null;
    },
    true
  );
})();
